export default __webpack_public_path__ + "static/media/tubeCutting.8731f0db.webp";